import React, { useState, useEffect } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncCreatableSelect from "react-select/async-creatable";
import axios from "../../axios";
import "./Dropdown.css";

const Dropdown = (props) => {
  const {
    datasource = [],
    name = "",
    // id = "",
    text = "",
    disabled = false,
    value = "",
    onChange,
    required = false,
    // placeholder = "Please select",
    ajax = false,
    api_url = "",
    allow_new_item = false,
    multiple = false,
  } = props;

  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    // If value is empty, clear selection
    if (value === "" || value === null || value === undefined) {
      if (selectedOption !== null) {
        setSelectedOption(null);
      }
      return;
    }

    // Try to sync props.value to selectedOption
    if (ajax) {
      // For async, we construct the option from value/text props
      // Only update if currently mismatch or null?
      // Original logic was convoluted. Here we ensure that if value is present,
      // we reflect it.
      if (!selectedOption || selectedOption.value != value) {
        setSelectedOption({
          value: value,
          label: text || value,
        });
      }
    } else {
      // Synchronous: look up in datasource
      // We check if we need to update to avoid loops, though strict equality check on object might fail unless we check values.
      // But here we reconstruct.

      const found = datasource.find((item) => item.key == value);

      if (found) {
        if (!selectedOption || selectedOption.value != found.key) {
          setSelectedOption({
            value: found.key,
            label: found.label,
          });
        }
      } else if (allow_new_item) {
        if (!selectedOption || selectedOption.value != value) {
          setSelectedOption({
            value: value,
            label: value,
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, datasource, ajax, text, allow_new_item]);
  // Omitted selectedOption from deps to avoid loop, checking it inside.

  const handleChange = (option) => {
    setSelectedOption(option);

    if (onChange) {
      if (option !== null) {
        let valToEmit;
        if (Array.isArray(option)) {
          valToEmit = option.map((o) => o.value);
          if (!multiple) valToEmit = option.value;
        } else {
          valToEmit = option.value;
        }

        const payloadValue = Array.isArray(option) ? option.map(o => o.value) : option.value;

        onChange({ [name]: payloadValue });
      } else {
        onChange({ [name]: null });
      }
    }
  };

  const getAsyncOptions = (inputValue) => {
    return new Promise((resolve) => {
      const params = {
        term: { term: inputValue },
      };
      const url = `${axios.defaults.baseURL}/${api_url}`;

      axios.post(url, params).then((res) => {
        const data = res.data.map((item) => ({
          value: item.id,
          label: item.text,
        }));
        resolve(data);
      });
    });
  };

  let ComponentToRender;
  let componentProps = {
    isClearable: true,
    className: "ddl",
    classNamePrefix: "ddl",
    value: selectedOption,
    isDisabled: disabled,
    isMulti: multiple,
    onChange: handleChange,
    placeholder: props.placeholder // Pass placeholder if present
  };

  if (ajax && allow_new_item) {
    ComponentToRender = AsyncCreatableSelect;
    componentProps = {
      ...componentProps,
      cacheOptions: true,
      defaultOptions: true,
      loadOptions: getAsyncOptions,
    };
  } else {
    // Prepare options from datasource
    const options = datasource.map((item) => ({
      value: item.key,
      label: item.label,
    }));
    componentProps.options = options;

    if (allow_new_item) {
      ComponentToRender = CreatableSelect;
    } else {
      ComponentToRender = Select;
    }
  }

  return (
    <div>
      <ComponentToRender {...componentProps} />
      {!disabled && (
        <input
          tabIndex={-1}
          autoComplete="off"
          style={{
            opacity: 0,
            height: 0,
            width: "100%",
            position: "absolute",
          }}
          defaultValue={value || ""}
          required={required}
        />
      )}
    </div>
  );
};

export default Dropdown;
